import React from "react";

function IconPictureUpload({ size = 24 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 49 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M44.9167 24.5C44.9167 23.3724 44.0027 22.4583 42.875 22.4583C41.7474 22.4583 40.8334 23.3724 40.8334 24.5H44.9167ZM24.5 8.16668C25.6277 8.16668 26.5417 7.25259 26.5417 6.12501C26.5417 4.99743 25.6277 4.08334 24.5 4.08334V8.16668ZM39.8125 40.8333H9.18754V44.9167H39.8125V40.8333ZM8.16671 39.8125V9.18751H4.08337V39.8125H8.16671ZM40.8334 24.5V39.8125H44.9167V24.5H40.8334ZM9.18754 8.16668H24.5V4.08334H9.18754V8.16668ZM9.18754 40.8333C8.62375 40.8333 8.16671 40.3763 8.16671 39.8125H4.08337C4.08337 42.6314 6.36858 44.9167 9.18754 44.9167V40.8333ZM39.8125 44.9167C42.6315 44.9167 44.9167 42.6314 44.9167 39.8125H40.8334C40.8334 40.3763 40.3763 40.8333 39.8125 40.8333V44.9167ZM8.16671 9.18751C8.16671 8.62372 8.62374 8.16668 9.18754 8.16668V4.08334C6.36859 4.08334 4.08337 6.36855 4.08337 9.18751H8.16671Z"
        fill="currentColor"
      />
      <path
        d="M6.125 35.7292L17.0409 25.723C17.8022 25.025 18.9649 25.0056 19.7491 25.6778L32.6667 36.75"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M28.5834 31.6458L33.4563 26.7729C34.1747 26.0545 35.3121 25.9737 36.125 26.5833L42.875 31.6458"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.7709 18.375V6.125"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.6667 11.2292L37.7709 6.125L42.8751 11.2292"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default IconPictureUpload;
